const url = process.env.REACT_APP_API_URL
const authUrl = process.env.REACT_APP_API_AUTH_URL

export {url, authUrl}
